import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: /*@__PURE__*/_normalizeClass(`as-goals-scored`)
}
const _hoisted_2 = { class: "as-goals-scored__head" }
const _hoisted_3 = { class: "as-history" }
const _hoisted_4 = { class: "as-history-item" }
const _hoisted_5 = { class: "as-history-item__head" }
const _hoisted_6 = { class: "as-history-item__body" }
const _hoisted_7 = { class: "as-competition" }
const _hoisted_8 = { class: "as-competition__table" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "as-center a" }
const _hoisted_12 = { class: "as-center a" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "as-competition"
}
const _hoisted_15 = { class: "as-competition__table" }
const _hoisted_16 = { class: "as-center a" }
const _hoisted_17 = { class: "as-center a" }
const _hoisted_18 = { class: "as-center" }
const _hoisted_19 = { class: "as-center" }
const _hoisted_20 = { class: "as-center" }
const _hoisted_21 = { class: "as-center" }
const _hoisted_22 = { class: "as-center" }
const _hoisted_23 = { class: "as-center" }
const _hoisted_24 = { class: "as-center" }
const _hoisted_25 = { class: "as-center" }
const _hoisted_26 = { class: "as-center" }
const _hoisted_27 = { class: "as-center" }
const _hoisted_28 = { class: "as-center" }
const _hoisted_29 = { class: "as-center" }
const _hoisted_30 = { class: "as-center" }
const _hoisted_31 = { class: "as-center" }
const _hoisted_32 = { class: "as-center" }
const _hoisted_33 = { key: 2 }
const _hoisted_34 = {
  key: 3,
  class: "as-competition"
}
const _hoisted_35 = { class: "as-competition__table" }
const _hoisted_36 = { class: "as-center a" }
const _hoisted_37 = { class: "as-center a" }
const _hoisted_38 = { class: "as-center" }
const _hoisted_39 = { class: "as-center" }
const _hoisted_40 = { class: "as-center" }
const _hoisted_41 = { class: "as-center" }
const _hoisted_42 = { class: "as-center" }
const _hoisted_43 = { class: "as-center" }
const _hoisted_44 = { class: "as-center" }
const _hoisted_45 = { class: "as-center" }
const _hoisted_46 = { class: "as-center" }
const _hoisted_47 = { class: "as-center" }
const _hoisted_48 = { class: "as-center" }
const _hoisted_49 = { class: "as-center" }

import { ref, computed } from "vue";
import IconTheShot from "~src/components/icons/foot_stats/IconTheShot.vue";
import type { IMatch } from "~src/interfaces";
import type {
  IDataKeys,
  IFootyStats,
  ITeam,
  IStatsParent,
} from "~src/interfaces/footystats";
import { getClassForItem } from "~src/helpers/footystats";


const __default__ = {};

interface Props {
  match: IMatch;
  mode?: string;
  footyStats: IFootyStats | null;
  homeTeamInfo: ITeam | null;
  awayTeamInfo: ITeam | null;
}

interface IData {
  title: string;
  home: {
    value: number;
    _class: string;
  };
  away: {
    value: number;
    _class: string;
  };
  avg: {
    value: number;
    _class: string;
  };
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'TheShotList',
  props: {
    match: {},
    mode: { default: "as-win" },
    footyStats: {},
    homeTeamInfo: {},
    awayTeamInfo: {}
  },
  setup(__props: any) {

const props = __props;

const activeTab = ref("team");
const setActiveTab = (tab: string) => {
  activeTab.value = tab;
};
const createDataItem = (
  title: string,
  key: string,
  is_stats: boolean = true,
  is_percent: boolean = true
) => {
  const homeValue = getValueWithMode("home", key, is_stats);
  const awayValue = getValueWithMode("away", key, is_stats);
  const avgValue = calculatorAVG(homeValue, awayValue);

  return {
    title,
    home: {
      value: homeValue,
      _class: getClassForItem(homeValue),
      is_percent: is_percent,
    },
    away: {
      value: awayValue,
      _class: getClassForItem(awayValue),
      is_percent: is_percent,
    },
    avg: {
      value: avgValue,
      _class: getClassForItem(avgValue),
      is_percent: is_percent,
    },
  };
};

const data = computed(() => {
  let dataKeys: IDataKeys[] = [
    {
      title: "Số cú sút đã thực hiện",
      key: "shotsAVG_overall",
      is_percent: false,
    },
    {
      title: "Tỷ lệ chuyển đổi cú sút",
      key: "shot_conversion_rate_overall",
      is_percent: true,
      is_stats: false
    },
    {
      title: "Cú sút trúng/Trận đấu",
      key: "shotsOnTargetAVG_overall",
      is_percent: false,
    },
    {
      title: "Cú sút trượt/Trận đấu",
      key: "shotsOffTargetAVG_overall",
      is_percent: false,
    },
    {
      title: "Số lần sút mỗi bàn thắng",
      key: "shots_per_goals_scored_overall",
      is_percent: false,
      is_stats: false
    },
    {
      title: "Cú sút của đội trên 10.5",
      key: "team_shots_over105_percentage_overall",
      is_stats: false
    },
    {
      title: "Cú sút của đội trên 11.5",
      key: "team_shots_over115_percentage_overall",
      is_stats: false
    },
    {
      title: "Cú sút của đội trên 12.5",
      key: "team_shots_over125_percentage_overall",
      is_stats: false
    },
    {
      title: "Cú sút của đội trên 13.5",
      key: "team_shots_over135_percentage_overall",
      is_stats: false
    },
    {
      title: "Cú sút của đội trên 14.5",
      key: "team_shots_over145_percentage_overall",
      is_stats: false
    },
    {
      title: "Cú sút của đội trên 15.5",
      key: "team_shots_over155_percentage_overall",
      is_stats: false
    },
    {
      title: "Cú sút của đội trên 3.5",
      key: "team_shots_on_target_over35_percentage_overall",
      is_stats: false
    },
    {
      title: "Cú sút của đội trên 4.5",
      key: "team_shots_on_target_over45_percentage_overall",
      is_stats: false
    },
    {
      title: "Cú sút của đội trên 5.5",
      key: "team_shots_on_target_over55_percentage_overall",
      is_stats: false
    },
  ];

  if (activeTab.value == "all") {
    dataKeys = [
      {
        title: "Match Shots Over 23.5",
        key: "match_shots_over235_percentage_overall",
        is_stats: false,
      },
      {
        title: "Match Shots Over 24.5",
        key: "match_shots_over245_percentage_overall",
        is_stats: false,
      },
      {
        title: "Match Shots Over 25.5",
        key: "match_shots_over255_percentage_overall",
        is_stats: false,
      },
      {
        title: "Match Shots Over 26.5",
        key: "match_shots_over265_percentage_overall",
        is_stats: false,
      },
      {
        title: "Match Shots On Target Over 7.5",
        key: "match_shots_on_target_over75_percentage_overall",
        is_stats: false,
      },
      {
        title: "Match Shots On Target Over 8.5",
        key: "match_shots_on_target_over85_percentage_overall",
        is_stats: false,
      },
      {
        title: "Match Shots On Target Over 9.5",
        key: "match_shots_on_target_over95_percentage_overall",
        is_stats: false,
      },
    ];
  }
  const _data = dataKeys.map((item: IDataKeys) => {
    return createDataItem(
      item.title,
      item.key,
      item.is_stats ?? true,
      item.is_percent ?? true
    );
  });

  return _data;
});

const homeTeamLastX = computed<IStatsParent>(() => {
  return props.footyStats?.home_team_last_x ?? ({} as IStatsParent);
});

const awayTeamLastX = computed<IStatsParent>(() => {
  return props.footyStats?.away_team_last_x ?? ({} as IStatsParent);
});

const getValueWithMode = (team = "home", mode = "btts", is_stats = true) => {
  const __data: IStatsParent =
    team === "home" ? homeTeamLastX.value : awayTeamLastX.value;

  if (!__data || !__data.stats) {
    return 0;
  }

  const targetStats = is_stats ? __data?.stats : __data?.stats?.additional_info;

  if (targetStats && targetStats.hasOwnProperty(mode)) {
    return targetStats[mode] as number;
  }

  return 0;
};

const calculatorAVG = (home: number, away: number) => {
  const _avg = (home + away) / 2;

  return Math.round(_avg);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(IconTheShot),
      _cache[2] || (_cache[2] = _createElementVNode("span", null, " Cú sút được thực hiện ", -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["as-head-tab as-uppercase", {
              'as-active': activeTab.value === 'team',
            }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (setActiveTab('team')))
          }, " Đội dứt điểm ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["as-head-tab as-uppercase", {
              'as-active': activeTab.value === 'all',
            }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (setActiveTab('all')))
          }, " Cú sút toàn trận ", 2)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("table", _hoisted_8, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  (activeTab.value === 'team')
                    ? (_openBlock(), _createElementBlock("th", _hoisted_9, " Số cú sút đã thực hiện/... "))
                    : _createCommentVNode("", true),
                  (activeTab.value === 'all')
                    ? (_openBlock(), _createElementBlock("th", _hoisted_10, "Match Shots"))
                    : _createCommentVNode("", true),
                  _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.footyStats?.home_name), 1),
                  _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.footyStats?.away_name), 1),
                  _cache[3] || (_cache[3] = _createElementVNode("th", { class: "as-center a" }, "Trung bình", -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", null, _toDisplayString(item.title), 1),
                    _createElementVNode("td", {
                      class: _normalizeClass(`as-center ${item.home._class}`)
                    }, _toDisplayString(item.home.value) + _toDisplayString(item.home.is_percent ? "%" : ""), 3),
                    _createElementVNode("td", {
                      class: _normalizeClass(`as-center ${item.away._class}`)
                    }, _toDisplayString(item.away.value) + _toDisplayString(item.away.is_percent ? "%" : ""), 3),
                    _createElementVNode("td", {
                      class: _normalizeClass(`as-center ${item.avg._class}`)
                    }, _toDisplayString(item.avg.value) + _toDisplayString(item.avg.is_percent ? "%" : ""), 3)
                  ]))
                }), 128))
              ])
            ])
          ]),
          (activeTab.value === 'all')
            ? (_openBlock(), _createElementBlock("br", _hoisted_13))
            : _createCommentVNode("", true),
          (activeTab.value === 'all')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("table", _hoisted_15, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[4] || (_cache[4] = _createElementVNode("th", null, "Offside Stats", -1)),
                      _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.footyStats?.home_name), 1),
                      _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.footyStats?.away_name), 1),
                      _cache[5] || (_cache[5] = _createElementVNode("th", { class: "as-center a" }, "Trung bình", -1))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[6] || (_cache[6] = _createElementVNode("td", null, "Offsides / Match", -1)),
                      _createElementVNode("td", _hoisted_18, _toDisplayString(getValueWithMode("home", "offsidesAVG_overall")), 1),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(getValueWithMode("away", "offsidesAVG_overall")), 1),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(calculatorAVG(
                        getValueWithMode("home", "offsidesAVG_overall"),
                        getValueWithMode("away", "offsidesAVG_overall")
                      )), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[7] || (_cache[7] = _createElementVNode("td", null, "Over 0.5 Offsides", -1)),
                      _createElementVNode("td", _hoisted_21, _toDisplayString(getValueWithMode(
                        "home",
                        "over05OffsidesPercentage_overall"
                      )) + "% ", 1),
                      _createElementVNode("td", _hoisted_22, _toDisplayString(getValueWithMode(
                        "away",
                        "over05OffsidesPercentage_overall"
                      )) + "% ", 1),
                      _createElementVNode("td", _hoisted_23, _toDisplayString(calculatorAVG(
                        getValueWithMode(
                          "home",
                          "over05OffsidesPercentage_overall"
                        ),
                        getValueWithMode(
                          "away",
                          "over05OffsidesPercentage_overall"
                        )
                      )) + "% ", 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[8] || (_cache[8] = _createElementVNode("td", null, "Over 1.5 Offsides", -1)),
                      _createElementVNode("td", _hoisted_24, _toDisplayString(getValueWithMode(
                        "home",
                        "over15OffsidesPercentage_overall"
                      )) + "% ", 1),
                      _createElementVNode("td", _hoisted_25, _toDisplayString(getValueWithMode(
                        "away",
                        "over15OffsidesPercentage_overall"
                      )) + "% ", 1),
                      _createElementVNode("td", _hoisted_26, _toDisplayString(calculatorAVG(
                        getValueWithMode(
                          "home",
                          "over15OffsidesPercentage_overall"
                        ),
                        getValueWithMode(
                          "away",
                          "over15OffsidesPercentage_overall"
                        )
                      )) + "% ", 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[9] || (_cache[9] = _createElementVNode("td", null, "Over 2.5 Offsides", -1)),
                      _createElementVNode("td", _hoisted_27, _toDisplayString(getValueWithMode(
                        "home",
                        "over25OffsidesPercentage_overall"
                      )) + "% ", 1),
                      _createElementVNode("td", _hoisted_28, _toDisplayString(getValueWithMode(
                        "away",
                        "over25OffsidesPercentage_overall"
                      )) + "% ", 1),
                      _createElementVNode("td", _hoisted_29, _toDisplayString(calculatorAVG(
                        getValueWithMode(
                          "home",
                          "over25OffsidesPercentage_overall"
                        ),
                        getValueWithMode(
                          "away",
                          "over25OffsidesPercentage_overall"
                        )
                      )) + "% ", 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[10] || (_cache[10] = _createElementVNode("td", null, "Over 3.5 Offsides", -1)),
                      _createElementVNode("td", _hoisted_30, _toDisplayString(getValueWithMode(
                        "home",
                        "over35OffsidesPercentage_overall"
                      )) + "% ", 1),
                      _createElementVNode("td", _hoisted_31, _toDisplayString(getValueWithMode(
                        "away",
                        "over35OffsidesPercentage_overall"
                      )) + "% ", 1),
                      _createElementVNode("td", _hoisted_32, _toDisplayString(calculatorAVG(
                        getValueWithMode(
                          "home",
                          "over35OffsidesPercentage_overall"
                        ),
                        getValueWithMode(
                          "away",
                          "over35OffsidesPercentage_overall"
                        )
                      )) + "% ", 1)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (activeTab.value === 'all')
            ? (_openBlock(), _createElementBlock("br", _hoisted_33))
            : _createCommentVNode("", true),
          (activeTab.value === 'all')
            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                _createElementVNode("table", _hoisted_35, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[11] || (_cache[11] = _createElementVNode("th", null, "Misc Stats", -1)),
                      _createElementVNode("th", _hoisted_36, _toDisplayString(_ctx.footyStats?.home_name), 1),
                      _createElementVNode("th", _hoisted_37, _toDisplayString(_ctx.footyStats?.away_name), 1),
                      _cache[12] || (_cache[12] = _createElementVNode("th", { class: "as-center a" }, "Trung bình", -1))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[13] || (_cache[13] = _createElementVNode("td", null, "Fouls Committed / Match", -1)),
                      _createElementVNode("td", _hoisted_38, _toDisplayString(getValueWithMode("home", "foulsAVG_overall")), 1),
                      _createElementVNode("td", _hoisted_39, _toDisplayString(getValueWithMode("away", "foulsAVG_overall")), 1),
                      _createElementVNode("td", _hoisted_40, _toDisplayString(calculatorAVG(
                        getValueWithMode("home", "foulsAVG_overall"),
                        getValueWithMode("away", "foulsAVG_overall")
                      )), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[14] || (_cache[14] = _createElementVNode("td", null, "Fouled Against / Match", -1)),
                      _createElementVNode("td", _hoisted_41, _toDisplayString(getValueWithMode("home", "fouls_against_avg_overall", false)), 1),
                      _createElementVNode("td", _hoisted_42, _toDisplayString(getValueWithMode("away", "fouls_against_avg_overall", false)), 1),
                      _createElementVNode("td", _hoisted_43, _toDisplayString(calculatorAVG(
                        getValueWithMode("home", "fouls_against_avg_overall", false),
                        getValueWithMode("away", "fouls_against_avg_overall", false)
                      )), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[15] || (_cache[15] = _createElementVNode("td", null, "Average Possession", -1)),
                      _createElementVNode("td", _hoisted_44, _toDisplayString(getValueWithMode("home", "possessionAVG_overall")) + "% ", 1),
                      _createElementVNode("td", _hoisted_45, _toDisplayString(getValueWithMode("away", "possessionAVG_overall")) + "% ", 1),
                      _createElementVNode("td", _hoisted_46, _toDisplayString(calculatorAVG(
                        getValueWithMode("home", "possessionAVG_overall"),
                        getValueWithMode("away", "possessionAVG_overall")
                      )) + "% ", 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[16] || (_cache[16] = _createElementVNode("td", null, "Draw % FT", -1)),
                      _createElementVNode("td", _hoisted_47, _toDisplayString(getValueWithMode("home", "drawPercentage_overall")) + "% ", 1),
                      _createElementVNode("td", _hoisted_48, _toDisplayString(getValueWithMode("away", "drawPercentage_overall")) + "% ", 1),
                      _createElementVNode("td", _hoisted_49, _toDisplayString(calculatorAVG(
                        getValueWithMode("home", "drawPercentage_overall"),
                        getValueWithMode("away", "drawPercentage_overall")
                      )) + "% ", 1)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})